import {
  MenuItem,
} from '@mui/material';
import { useArchiveLessonForTeacher } from '../../../../../lessons/lessonactions/hooks/ArchiveUnarchiveHooks';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  lesson: {},
  onActionComplete: () => { },
  onClick: () => { },
};

const ArchiveUnarchiveMenuItem = (p) => {
  const {
    lesson,
    onActionComplete,
    onClick,
  } = { ...defaultProps, ...filterUndefined({ ...p }) };
  const { archiveLesson } = useArchiveLessonForTeacher();
  const handleArchiveLesson = async (archiveFlag) => {
    await archiveLesson([lesson], archiveFlag);
    if (onActionComplete) {
      onActionComplete();
    }
  };

  return (
    lesson.meta.archived ? (
      <MenuItem tabIndex={0} onClick={() => { onClick(); handleArchiveLesson(false); }}>Unarchive</MenuItem>
    ) : (
      <MenuItem tabIndex={0} onClick={() => { onClick(); handleArchiveLesson(true); }}>Archive</MenuItem>
    )
  );
};

export default ArchiveUnarchiveMenuItem;
